import { api } from "_shared/_stores/api";
import { logSchemaFailure } from "_shared/_utilities/log-schema-failure";
import ClientTeamSchema, {
  ClientTeamJSON,
} from "work/work-agreements/teams/client-team/_schema/client-team-schema";
import VendorTeamSchema, { VendorTeamJSON } from "work/work-agreements/teams/vendor-team/_schemas/vendor-team-schema";
import z from "zod";

export const teamsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getActiveVendorTeams: build.query<VendorTeamJSON[], { workingForMe: boolean; interfaceName: string }>({
      query: ({ workingForMe }) => ({
        url: "work/vendor-teams",
        params: new URLSearchParams({ workingForMe: String(workingForMe) }),
      }),
      rawResponseSchema: z.array(VendorTeamSchema.VendorTeamJSONZ),
      onSchemaFailure: logSchemaFailure,
    }),
    getActiveClientTeams: build.query<ClientTeamJSON[], { interfaceName: string }>({
      query: () => "work/client-teams",
      rawResponseSchema: z.array(ClientTeamSchema.ClientTeamJSONZ),
      onSchemaFailure: logSchemaFailure,
    }),
  }),
});

export const { useGetActiveClientTeamsQuery, useGetActiveVendorTeamsQuery } = teamsApi;

export class InvalidVendorTeamError extends Error {
  public method: string;
  public error: unknown;
  constructor(method: string, error: unknown) {
    super(`Error in ${method}: ${String(error)}`);
    this.method = method;
    this.error = error;
    this.name = "InvalidVendorTeamError";
  }
}
